import { useCallback } from "react";
import { useLoading } from "./ProgressContext";

const CalendarServices = () => {
  const { axiosInstance } = useLoading();

  const getEvents = useCallback(async (month) => {
    try {
      const response = await axiosInstance.get("api/Calendar/events", {
        params: { month },
      });

      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      if (error.response?.status === 404) {
        return [];
      }

      throw error;
    }
  }, [axiosInstance]);

  const getRahuKalayaEvents = useCallback(async (payload) => {
    const response = await axiosInstance.post("api/muhurtha/rahukalaya", payload);
    return Array.isArray(response.data) ? response.data : [];
  }, [axiosInstance]);

  return { getEvents, getRahuKalayaEvents };
};

export default CalendarServices;
